import cn from 'clsx'
import s from './ScanningBlock.module.scss'
import { FC, useRef } from 'react'
import { Text, CustomImage, Container, Button } from '@components/ui'

import Image from 'next/image'
import { HomepagePowerSectionsInner } from '@generated/model/homepagePowerSectionsInner'

type ScanningBlockProps = {
  block: HomepagePowerSectionsInner
  index: number
}

const ScanningBlock: FC<ScanningBlockProps> = ({ block, index }) => {
  return (
    <>
      <div className={s.root}>
        <div className={s.image}>
          <Image
            src={block.image as string}
            alt={block.alt}
            layout="fill"
            objectFit="cover"
            //   width={block.image_width}
            //   height={block.image_height}
          />
        </div>
        <div className={s.titleContainer}>
          <Text variant="sectionHeading" className={s.title}>
            {String(index).padStart(2, '0')}
            <br />
            {block.title}
          </Text>
          <div className={s.arrow}>
            <Image
              src={'/Arrow-Right.svg'}
              alt="Arrow Right"
              width={50}
              height={44}
            />
          </div>
        </div>
        <Text className={s.description} html={block.detail} />
      </div>
    </>
  )
}

export default ScanningBlock
